// extracted by mini-css-extract-plugin
module.exports = {"status":"UserApplicationsTable_status__2HJGk","actionButtonWrapper":"UserApplicationsTable_actionButtonWrapper__3mLXG","actionButton":"UserApplicationsTable_actionButton__2TGsL"};